const filterViewFormDefaultValues = {
  name: '',
  assigned_to: [],
  shipper_id: [],
  vehicle_type: [],
  working_area_id: [],
};

export default filterViewFormDefaultValues;
